import React from "react";
import { Outlet } from "react-router-dom";

const ServicePageLayout = () => (
  <>
    <Outlet />
  </>
);
export default ServicePageLayout;
